module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/registereddoc/registerdoc-grid/registerdoc-grid.component.css
// module id = ./src/app/landprocurement/registereddoc/registerdoc-grid/registerdoc-grid.component.css
// module chunks = main